import React from "react";

import { sqlDateToHumanDate, safeValue, getPropInSubLevelRole } from "../../utils/globalFunctions";
import LabelContentInline from "../../components/general/LabelContentInline";

const BarangKategoriData = ({ stateData }) => {
    return (
        <React.Fragment>
            <LabelContentInline
                stateColLabel={4}
                stateLabel='Nama'
                stateContent={stateData.barang_category_name}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Status'
                stateContent={stateData.barang_category_is_active === '1' ? 'Aktif' : 'Non Aktif'}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Tanggal Input'
                stateContent={sqlDateToHumanDate({
                    stateDate: stateData.barang_category_created_datetime,
                    stateWithTime: true,
                    stateLang: 'id',
                    stateIsShort: false,
                    stateDay: false,
                    stateDefaultValue: ' - ',
                    stateDateType: 'day'
                })}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Diinput Oleh'
                stateContent={safeValue(stateData.barang_category_created_user_name, '-')}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Jabatan'
                stateContent={getPropInSubLevelRole(stateData.barang_category_created_user_sub_level, 'caption', '-')}
                stateDivider={false}
            />
        </React.Fragment>
    )
}

export default BarangKategoriData;